module.exports = __webpack_public_path__ + "static/media/the.943c2904.png";